import { Injectable } from '@angular/core';
import {CurrencyPipe} from '@angular/common';
import {User} from '../interfaces/user';
import {Serializer} from '../interfaces/serializer';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  constructor() { }

  public format(user: Serializer<User> | undefined | null, value: string | number, currencyCode: string, decimals: number = 2): string {
    const digitsInfo = `0.${decimals}-2`;
    return new CurrencyPipe(user?.attributes?.number_format || 'fr-FR').transform(value, currencyCode.toUpperCase(), 'symbol', digitsInfo);
  }

}
